import Image from "next/image";
import React from "react";

export default function NavButton({ toggleDrawer }) {
  return (
    <div className="lg:hidden">
      <button onClick={toggleDrawer}>
        <Image
          src="/assets/icon/menu.png"
          alt="menu icon"
          width={24}
          height={24}
          className="h-6 w-6 cursor-pointer"
        />
      </button>
    </div>
  );
}
